// src/components/common/PageHeader.jsx
/**
 * PageHeader Component
 * 
 * Reusable header component that displays page title, subtitle, and optional action button.
 * Provides consistent header styling across different pages.
 * 
 * Functions:
 * - onAction: Callback function for action button click events
 */

import React from 'react';
import Button from './Button';

const PageHeader = ({ 
  title, 
  subtitle, 
  actionText, 
  onAction, 
  showAction = true,
  className = '' 
}) => {
  return (
    <div className={`mb-6 ${className}`}>
      <div className="flex justify-between items-start">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
          {subtitle && (
            <p className="mt-1 text-sm text-gray-600">{subtitle}</p>
          )}
        </div>
        {showAction && actionText && onAction && (
          <Button
            onClick={onAction}
            className="bg-blue-600 hover:bg-blue-700"
          >
            {actionText}
          </Button>
        )}
      </div>
    </div>
  );
};

export default PageHeader;